const master = () => import(/* webpackPrefetch: true */ '@/views/private/master.vue')
// const satuan = () => import(/* webpackPrefetch: true */ '@/views/private/master/satuan/index.vue')
// const pelanggan = () => import(/* webpackPrefetch: true */ '@/views/private/master/pelanggan/index.vue')
// const type_penjualan = () => import(/* webpackPrefetch: true */ '@/views/private/master/type-penjualan/index.vue')
// const bank = () => import(/* webpackPrefetch: true */ '@/views/private/master/bank/index.vue')


const menu_master = () => import(/* webpackPrefetch: true */ '@/views/private/menu-master.vue')

const routes = [
  {
    path: "/master",
    name: "Master",
    component: master,
    meta: {
      title: "Master"
    },
    children: [
      // {
      //   path: "/master/satuan",
      //   name: "Satuan",
      //   component: satuan,
      //   meta: {
      //     title: "Data Satuan"
      //   }
      // },
      // {
      //   path: "/master/pelanggan",
      //   name: "Pelanggan",
      //   component: pelanggan,
      //   meta: {
      //     title: "Data Pelanggan"
      //   }
      // },
      // {
      //   path: "/master/type-penjualan",
      //   name: "Type Penjualan",
      //   component: type_penjualan,
      //   meta: {
      //     title: "Data Type Penjualan"
      //   }
      // },
      // {
      //   path: "/master/bank",
      //   name: "Bank",
      //   component: bank,
      //   meta: {
      //     title: "Data Bank"
      //   }
      // }
    ]
  },
  {
    path: "/menu-master",
    name: "Menu Master",
    component: menu_master,
    meta: {
      title: "Menu Master"
    }
  }
  // {
  //   path: "/master/satuan",
  //   name: "Satuan",
  //   component: satuan,
  //   meta: {
  //     title: "Data Satuan"
  //   }
  // },
  // {
  //   path: "/master-pembelian/lokasi",
  //   name: "Bagian",
  //   component: lokasi,
  //   meta: {
  //     title: "Data Bagian"
  //   }
  // },
  // {
  //   path: "/master-pembelian/lokasi/detail/:id",
  //   name: "Bagian Detail",
  //   component: lokasi_detail,
  //   meta: {
  //     title: "Detail Bagian"
  //   }
  // },
  // {
  //   path: "/master-pembelian/lokasi/edit/:id",
  //   name: "Bagian Edit",
  //   component: lokasi_adit,
  //   meta: {
  //     title: "Edit Bagian"
  //   }
  // },
  // {
  //   path: "/master-pembelian/lokasi/add",
  //   name: "Bagian Add",
  //   component: lokasi_add,
  //   meta: {
  //     title: "Tambah Bagian"
  //   }
  // }


  
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})